import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Api from '../../../api';
import {SetProjectEmployeeRatePayload} from '../../actions/dashboardCommand';

const onSetProjectEmployeeRate = function*(data: SetProjectEmployeeRatePayload) {
    try {
        yield call(Api.Command.Rate.setProjectEmployeeRate, data.projectId, data.userId, data.hourlyRate);

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Projekt-Stundensatz wurde gespeichert.',
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Projekt-Stundensatz konnte nicht gespeichert werden.',
        }));
    }
};

export function* setProjectEmployeeRateFlow() {
    while (true) {
        const action: Action<SetProjectEmployeeRatePayload> =
            yield take(Command.Dashboard.setProjectEmployeeRate.toString());
        yield fork(onSetProjectEmployeeRate, action.payload);
    }
}
